import { render, staticRenderFns } from "./InspectionRecord.vue?vue&type=template&id=5adad3ee&scoped=true"
import script from "./InspectionRecord.vue?vue&type=script&lang=js"
export * from "./InspectionRecord.vue?vue&type=script&lang=js"
import style0 from "./InspectionRecord.vue?vue&type=style&index=0&id=5adad3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adad3ee",
  null
  
)

export default component.exports